// extracted by mini-css-extract-plugin
export default {"container":"games-groups_container__3Ejlt","item":"games-groups_item__2xPqQ"};